import { mapState } from 'vuex'

const SearchSessionStorageMixin = {
  computed: {
    ...mapState('eHorizonSearchForm', ['origin']),
    sessionStorageIsAvailable() {
      try {
        return !!sessionStorage
      } catch (exception) {
        return false
      }
    }
  },
  methods: {
    $_searchSessionStorageMixin_updateOriginSessionStorage(resetSession) {
      if (!this.sessionStorageIsAvailable) return
      let origin = this.$store.state.eHorizonSearchForm.origin.typeahead.value.code
      let type = this.$store.state.eHorizonSearchForm.origin.typeahead.value.type

      if (resetSession && origin !== sessionStorage.getItem('origin')) {
        this.resetSearchSessionStorage()
      }

      if (origin) {
        sessionStorage.setItem('origin', origin)
        sessionStorage.setItem('originType', type)
      }
    },

    $_searchSessionStorageMixin_updateDestinSessionStorage(resetSession) {
      if (!this.sessionStorageIsAvailable) return
      let destin = this.$store.state.eHorizonSearchForm.destin.value.code
      let type = this.$store.state.eHorizonSearchForm.destin.value.type

      if (resetSession && destin !== sessionStorage.getItem('destin')) {
        this.resetSearchSessionStorage()
      }

      if (destin) {
        sessionStorage.setItem('destin', destin)
        sessionStorage.setItem('destinType', type)
      }
    },

    resetSearchSessionStorage() {
      if (!this.sessionStorageIsAvailable) return
      sessionStorage.setItem('voucher', '')
      sessionStorage.setItem('adtPassengers', '')
      sessionStorage.setItem('chdPassengers', '')
      sessionStorage.setItem('infPassengers', '')
      sessionStorage.setItem('youngAdults', '')
      sessionStorage.setItem('tripType', '')
      sessionStorage.setItem('departure', '')
      sessionStorage.setItem('return', '')
    },

    $_searchSessionStorageMixin_updateVoucherSessionStorage() {
      if (!this.sessionStorageIsAvailable) return
      const vouchers = this.$store.state.eHorizonSearchForm.promoCodes.promoCodes
        .filter((code) => code.code !== '')
        .map((code) => code.code)
        .join(',')
      sessionStorage.setItem('voucher', vouchers)
    },
    /**
     * @param {string} key
     * @returns {string|null}
     */
    $_searchSessionStorageMixin_getSessionItem(key) {
      return this.sessionStorageIsAvailable ? sessionStorage.getItem(key) : null
    },

    /**
     * @param {string} key
     * @param {string} value
     */
    $_searchSessionStorageMixin_setSessionItem(key, value) {
      if (!this.sessionStorageIsAvailable) return
      sessionStorage.setItem(key, value)
    }
  }
}
export default SearchSessionStorageMixin
